export const config = {
    backEndOrigin: "https://inductions.delta.nitt.edu/api",
    captchaSiteKey: "6LeLwcAaAAAAAOw8axioT_a5m-OsyN08wMXRZPGu"
  };
